var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagramSecond(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "1161953_instagram_icon (2) 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.5801 7.06885C9.61714 7.06885 7.16211 9.48155 7.16211 12.4868C7.16211 15.4921 9.57481 17.9048 12.5801 17.9048C15.5854 17.9048 17.9981 15.4498 17.9981 12.4868C17.9981 9.52387 15.5431 7.06885 12.5801 7.06885ZM12.5801 15.9577C10.6753 15.9577 9.1092 14.3916 9.1092 12.4868C9.1092 10.5821 10.6753 9.01594 12.5801 9.01594C14.4849 9.01594 16.051 10.5821 16.051 12.4868C16.051 14.3916 14.4849 15.9577 12.5801 15.9577Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M18.2099 8.16938C18.8879 8.16938 19.4374 7.61981 19.4374 6.94187C19.4374 6.26393 18.8879 5.71436 18.2099 5.71436C17.532 5.71436 16.9824 6.26393 16.9824 6.94187C16.9824 7.61981 17.532 8.16938 18.2099 8.16938Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M21.3836 3.76719C20.2831 2.62433 18.717 2.03174 16.9392 2.03174H8.2196C4.53706 2.03174 2.08203 4.48676 2.08203 8.1693V16.8466C2.08203 18.6667 2.67462 20.2328 3.85981 21.3757C5.00267 22.4762 6.52648 23.0264 8.26193 23.0264H16.8968C18.717 23.0264 20.2408 22.4339 21.3413 21.3757C22.4841 20.2751 23.0767 18.709 23.0767 16.8889V8.1693C23.0767 6.39153 22.4841 4.86772 21.3836 3.76719ZM21.2143 16.8889C21.2143 18.2011 20.7487 19.2593 19.9868 19.9788C19.2249 20.6984 18.1667 21.0794 16.8968 21.0794H8.26193C6.99208 21.0794 5.93388 20.6984 5.17198 19.9788C4.41007 19.2169 4.02912 18.1587 4.02912 16.8466V8.1693C4.02912 6.89946 4.41007 5.84126 5.17198 5.07936C5.89156 4.35978 6.99208 3.97883 8.26193 3.97883H16.9815C18.2513 3.97883 19.3095 4.35978 20.0715 5.12169C20.791 5.88359 21.2143 6.94179 21.2143 8.1693V16.8889Z",
    fill: "black"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramSecond);
export default __webpack_public_path__ + "static/media/instagram_second.ea1cd917272d0fe97df04fcd09ef991c.svg";
export { ForwardRef as ReactComponent };